import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=99bc78be"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=99bc78be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports